{
  "PROFILE_SETTINGS": {
    "LINK": "Ustawienia profilu",
    "TITLE": "Ustawienia profilu",
    "BTN_TEXT": "Aktualizuj profil",
    "DELETE_AVATAR": "Usuń awatar",
    "AVATAR_DELETE_SUCCESS": "Awatar został usunięty",
    "AVATAR_DELETE_FAILED": "Wystąpił błąd podczas usuwania awatara, spróbuj ponownie",
    "UPDATE_SUCCESS": "Twój profil został pomyślnie zaktualizowany",
    "PASSWORD_UPDATE_SUCCESS": "Twoje hasło zostało zmienione",
    "AFTER_EMAIL_CHANGED": "Twój profil został pomyślnie zaktualizowany, zaloguj się ponownie po zmianie danych logowania",
    "FORM": {
      "PICTURE": "Zdjęcie profilowe",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Zdjęcie do podpisu e-mail",
        "HINT": "Używane w podpisach e-mail. {'{{'}email_signature_picture{'}}'} jest zastępowane adresem URL tego obrazu (a nie znacznikiem obrazu) — użyj go jako źródła obrazu (atrybutu src znacznika img) w swoim podpisie lub podpisie skrzynki. Jeśli nie ustawiono, nic nie zostanie wstawione.",
        "DELETE_SUCCESS": "Zdjęcie do podpisu e-mail zostało pomyślnie usunięte",
        "DELETE_FAILED": "Wystąpił błąd podczas usuwania zdjęcia do podpisu e-mail, spróbuj ponownie"
      },
      "AVATAR": "Zdjęcie profilowe",
      "ERROR": "Proszę naprawić błędy formularza",
      "REMOVE_IMAGE": "Usuń",
      "UPLOAD_IMAGE": "Prześlij obraz",
      "UPDATE_IMAGE": "Aktualizuj obraz",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Twój adres e-mail jest Twoją tożsamością i jest używany do logowania."
      },
      "SEND_MESSAGE": {
        "TITLE": "Skrót klawiszowy do wysyłania wiadomości",
        "NOTE": "Możesz wybrać skrót klawiszowy (Enter lub Cmd/Ctrl+Enter) zgodnie ze swoimi preferencjami pisania.",
        "UPDATE_SUCCESS": "Twoje ustawienia zostały pomyślnie zaktualizowane",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Wysyłaj wiadomości, naciskając klawisz Enter zamiast klikać przycisk wysyłania."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Wysyłaj wiadomości, naciskając Cmd/Ctrl + Enter zamiast klikać przycisk wysyłania."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interfejs",
        "NOTE": "Dostosuj wygląd i działanie swojego panelu.",
        "FONT_SIZE": {
          "TITLE": "Rozmiar czcionki",
          "NOTE": "Dostosuj rozmiar tekstu w panelu zgodnie z preferencjami.",
          "UPDATE_SUCCESS": "Ustawienia czcionki zostały pomyślnie zaktualizowane",
          "UPDATE_ERROR": "Wystąpił błąd podczas aktualizacji ustawień czcionki, spróbuj ponownie",
          "OPTIONS": {
            "SMALLER": "Mniejszy",
            "SMALL": "Mały",
            "DEFAULT": "Domyślny",
            "LARGE": "Duży",
            "LARGER": "Większy",
            "EXTRA_LARGE": "Bardzo duży"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Język panelu",
          "NOTE": "Zastąp język konta na potrzeby własnego panelu. Pozostaw puste, aby użyć domyślnego języka konta.",
          "USE_ACCOUNT_DEFAULT": "Użyj domyślnego języka konta",
          "API_SUCCESS": "Język panelu został pomyślnie zaktualizowany",
          "API_ERROR": "Wystąpił błąd podczas aktualizacji języka panelu, spróbuj ponownie"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Język wiadomości",
          "NOTE": "Wybierz, czy wyświetlać oryginalne wiadomości, czy ich tłumaczenia",
          "ORIGINAL": "Oryginał",
          "TRANSLATED": "Przetłumaczona"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Zachowanie wklejania",
          "NOTE": "Wybierz, jak przetwarzać wklejaną treść podczas tworzenia wiadomości",
          "UPDATE_SUCCESS": "Ustawienia wklejania zostały pomyślnie zaktualizowane",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Zachowaj całe formatowanie",
              "DESCRIPTION": "Zachowaj całe formatowanie, w tym tabele, style i inne elementy HTML przy wklejaniu treści."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Tekst tylko z linkami",
              "DESCRIPTION": "Konwertuj do zwykłego tekstu, zachowując klikalne linki przy wklejaniu treści."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Tylko zwykły tekst",
              "DESCRIPTION": "Usuń całe formatowanie i konwertuj do zwykłego tekstu przy wklejaniu treści."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Wysokość pola odpowiedzi",
          "NOTE": "Ustaw minimalną wysokość pola odpowiedzi jako procent wysokości ekranu. Dotyczy tylko rozmów e-mailowych.",
          "UPDATE_SUCCESS": "Ustawienie wysokości pola odpowiedzi zostało pomyślnie zaktualizowane",
          "PERCENT_LABEL": "Wysokość (% wysokości ekranu)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Domyślna",
              "DESCRIPTION": "Pole odpowiedzi zaczyna się małe i powiększa się w miarę pisania."
            },
            "CUSTOM": {
              "HEADING": "Niestandardowa",
              "DESCRIPTION": "Pole odpowiedzi ma zawsze co najmniej wybrany procent wysokości ekranu."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Automatyczne przejście do następnej rozmowy",
        "NOTE": "Automatycznie przełączaj do następnej otwartej rozmowy po rozwiązaniu bieżącej",
        "UPDATE_SUCCESS": "Ustawienie automatycznej nawigacji zostało zaktualizowane"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format podglądu wiadomości e-mail na liście rozmów",
        "NOTE": "Wybierz, co ma być wyświetlane na liście rozmów w przypadku konwersacji ze skrzynek e-mail",
        "SUBJECT": "Temat",
        "SUBJECT_WITH_NOTE": "Temat i ostatnia wiadomość, jeśli jest notatką wewnętrzną",
        "UPDATE_SUCCESS": "Ustawienie podglądu wiadomości e-mail zostało pomyślnie zaktualizowane"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Wyłącz skróty klawiszowe",
        "NOTE": "Wyłącz wszystkie skróty klawiszowe w całej aplikacji",
        "UPDATE_SUCCESS": "Ustawienie skrótów klawiszowych zostało zaktualizowane"
      },
      "FOLDER_ORDER": {
        "TITLE": "Kolejność folderów",
        "NOTE": "Dostosuj kolejność, w jakiej foldery (widoki niestandardowe) pojawiają się w panelu bocznym. Przeciągnij i upuść, aby zmienić kolejność.",
        "NO_FOLDERS": "Nie znaleziono folderów niestandardowych. Utwórz foldery, aby uporządkować rozmowy."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfiguracja panelu bocznego",
        "NOTE": "Dostosuj, które sekcje mają być widoczne w panelu bocznym rozmów.",
        "SAVE_BUTTON": "Zapisz konfigurację",
        "UPDATE_SUCCESS": "Konfiguracja panelu bocznego została zaktualizowana",
        "UPDATE_ERROR": "Wystąpił błąd podczas aktualizacji konfiguracji panelu bocznego, spróbuj ponownie",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Wszystkie rozmowy",
          "ALL_CONVERSATIONS_DESC": "Pokaż pozycję „Wszystkie rozmowy” w panelu bocznym",
          "INBOX": "Skrzynka odbiorcza",
          "INBOX_DESC": "Pokaż główną skrzynkę odbiorczą z nieprzeczytanymi powiadomieniami",
          "CONVERSATION_GROUPS": "Wzmianki i nieobsłużone",
          "CONVERSATION_GROUPS_DESC": "Pokaż grupy rozmów „Wzmianki” i „Nieobsłużone”",
          "FOLDERS": "Foldery",
          "FOLDERS_DESC": "Pokaż widoki niestandardowe (foldery) dla uporządkowanych rozmów",
          "TEAMS": "Zespoły",
          "TEAMS_DESC": "Pokaż rozmowy filtrowane według przypisanych zespołów",
          "CHANNELS": "Skrzynki",
          "CHANNELS_DESC": "Pokaż rozmowy filtrowane według skrzynki",
          "LABELS": "Etykiety",
          "LABELS_DESC": "Pokaż rozmowy filtrowane według etykiet"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Ustawienia telefonu",
        "NOTE": "Wprowadź dane logowania do systemu PBX.",
        "USERNAME": "Nazwa użytkownika",
        "PASSWORD": "Hasło",
        "SUBMIT": "Zapisz",
        "USERNAME_INVALID": "Nazwa użytkownika może zawierać tylko litery, cyfry oraz . _ - + — bez spacji i bez adresu e-mail.",
        "API": {
          "USERNAME_INVALID": "Nazwa użytkownika nie jest prawidłową nazwą użytkownika SIP. Używaj tylko liter, cyfr oraz . _ - + — bez spacji i bez adresu e-mail.",
          "USERNAME_TAKEN": "Ta nazwa użytkownika jest już używana przez innego agenta na tym koncie."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Osobisty podpis wiadomości",
        "DESCRIPTION": "Utwórz unikalny podpis wiadomości, który będzie pojawiał się na końcu każdego wysłanego e-maila. Możesz również dodać obraz w treści.",
        "NOTE": "Utwórz unikalny podpis wiadomości, który będzie pojawiał się na końcu każdej wiadomości wysyłanej z dowolnej skrzynki. Możesz także dodać obraz w treści, który jest obsługiwany w czacie na żywo, e-mailach i API.",
        "BTN_TEXT": "Zapisz podpis wiadomości",
        "API_ERROR": "Nie udało się zapisać podpisu! Spróbuj ponownie",
        "API_SUCCESS": "Podpis został zapisany pomyślnie",
        "IMAGE_UPLOAD_ERROR": "Nie udało się przesłać obrazu! Spróbuj ponownie",
        "IMAGE_UPLOAD_SUCCESS": "Obraz został dodany pomyślnie. Kliknij zapisz, aby zapisać podpis",
        "IMAGE_UPLOAD_SIZE_ERROR": "Rozmiar obrazu nie może przekraczać {size} MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Podpis wiadomości",
        "ERROR": "Podpis wiadomości nie może być pusty",
        "PLACEHOLDER": "Wstaw tutaj swój osobisty podpis wiadomości."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Hasło",
        "NOTE": "Aktualizacja hasła zresetuje Twoje logowania na wielu urządzeniach.",
        "BTN_TEXT": "Zmień hasło"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Token dostępu",
        "NOTE": "Ten token może być użyty, jeśli budujesz integrację opartą na API",
        "COPY": "Kopiuj",
        "REGENERATE": "Wygeneruj ponownie",
        "REGENERATE_SUCCESS": "Token dostępu został pomyślnie wygenerowany ponownie. Zaktualizuj wszystkie integracje korzystające ze starego tokena.",
        "REGENERATE_CONFIRM_TITLE": "Wygenerować ponownie token dostępu?",
        "REGENERATE_CONFIRM_MESSAGE": "Spowoduje to unieważnienie obecnego tokena. Wszystkie integracje korzystające ze starego tokena przestaną działać."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Rozszerzenie Chrome",
        "NOTE": "Zainstaluj nasze rozszerzenie Chrome, aby otrzymywać rozbudowane powiadomienia o przychodzących połączeniach.",
        "INSTALL_BUTTON": "Zainstaluj rozszerzenie",
        "ALREADY_INSTALLED": "Rozszerzenie zainstalowane"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Powiadomienia dźwiękowe",
        "NOTE": "Włącz powiadomienia dźwiękowe w panelu dla nowych wiadomości i rozmów.",
        "PLAY": "Odtwórz dźwięk",
        "ALERT_TYPES": {
          "NONE": "Brak",
          "MINE": "Przypisane do mnie",
          "ALL": "Wszystkie",
          "ASSIGNED": "Moje przypisane rozmowy",
          "UNASSIGNED": "Nieprzypisane rozmowy",
          "NOTME": "Otwarte rozmowy przypisane do innych"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Nie wybrałeś żadnych opcji, nie będziesz otrzymywać powiadomień dźwiękowych.",
          "ASSIGNED": "Będziesz otrzymywać powiadomienia o rozmowach przypisanych do Ciebie.",
          "UNASSIGNED": "Będziesz otrzymywać powiadomienia o nieprzypisanych rozmowach.",
          "NOTME": "Będziesz otrzymywać powiadomienia o rozmowach przypisanych do innych.",
          "ASSIGNED+UNASSIGNED": "Będziesz otrzymywać powiadomienia o swoich rozmowach i nieobsłużonych.",
          "ASSIGNED+NOTME": "Będziesz otrzymywać powiadomienia o rozmowach przypisanych do Ciebie i innych.",
          "NOTME+UNASSIGNED": "Będziesz otrzymywać powiadomienia o nieobsłużonych i przypisanych do innych rozmowach.",
          "ASSIGNED+NOTME+UNASSIGNED": "Będziesz otrzymywać powiadomienia o wszystkich rozmowach."
        },
        "ALERT_TYPE": {
          "TITLE": "Zdarzenia powiadomień dla rozmów",
          "NONE": "Brak",
          "ASSIGNED": "Przypisane rozmowy",
          "ALL_CONVERSATIONS": "Wszystkie rozmowy"
        },
        "DEFAULT_TONE": {
          "TITLE": "Ton powiadomienia:"
        },
        "CONDITIONS": {
          "TITLE": "Warunki powiadomień:",
          "CONDITION_ONE": "Wysyłaj powiadomienia dźwiękowe tylko wtedy, gdy okno przeglądarki nie jest aktywne",
          "CONDITION_TWO": "Wysyłaj powiadomienia co 10 s, dopóki wszystkie przypisane rozmowy nie zostaną przeczytane"
        },
        "SOUND_PERMISSION_ERROR": "Automatyczne odtwarzanie jest wyłączone w Twojej przeglądarce. Aby słyszeć powiadomienia, włącz uprawnienia dźwięku lub wejdź w interakcję ze stroną.",
        "READ_MORE": "Czytaj więcej"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Powiadomienia e-mail",
        "NOTE": "Zaktualizuj tutaj swoje preferencje powiadomień e-mail",
        "CONVERSATION_ASSIGNMENT": "Wysyłaj powiadomienia e-mail, gdy rozmowa zostanie przypisana do mnie",
        "CONVERSATION_CREATION": "Wysyłaj powiadomienia e-mail, gdy zostanie utworzona nowa rozmowa",
        "CONVERSATION_MENTION": "Wysyłaj powiadomienia e-mail, gdy zostaniesz wspomniany w rozmowie",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Wysyłaj powiadomienia e-mail, gdy pojawi się nowa wiadomość w przypisanej rozmowie",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Wysyłaj powiadomienia e-mail, gdy pojawi się nowa wiadomość w rozmowie, w której uczestniczysz",
        "SLA_MISSED_FIRST_RESPONSE": "Wysyłaj powiadomienia e-mail, gdy rozmowa nie spełni SLA pierwszej odpowiedzi",
        "SLA_MISSED_NEXT_RESPONSE": "Wysyłaj powiadomienia e-mail, gdy rozmowa nie spełni SLA kolejnej odpowiedzi",
        "SLA_MISSED_RESOLUTION": "Wysyłaj powiadomienia e-mail, gdy rozmowa nie spełni SLA rozwiązania"
      },
      "NOTIFICATIONS": {
        "TITLE": "Preferencje powiadomień",
        "TYPE_TITLE": "Typ powiadomienia",
        "EMAIL": "E-mail",
        "PUSH": "Powiadomienie push",
        "TYPES": {
          "CONVERSATION_CREATED": "Tworzona jest nowa rozmowa",
          "CONVERSATION_ASSIGNED": "Rozmowa jest przypisywana do Ciebie",
          "CONVERSATION_MENTION": "Zostajesz wspomniany w rozmowie",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Pojawia się nowa wiadomość w przypisanej rozmowie",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Pojawia się nowa wiadomość w rozmowie, w której uczestniczysz",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Pojawia się nowa wiadomość w rozmowie bez dostępnego agenta",
          "SLA_MISSED_FIRST_RESPONSE": "Rozmowa nie spełnia SLA pierwszej odpowiedzi",
          "SLA_MISSED_NEXT_RESPONSE": "Rozmowa nie spełnia SLA kolejnej odpowiedzi",
          "SLA_MISSED_RESOLUTION": "Rozmowa nie spełnia SLA rozwiązania"
        },
        "BROWSER_PERMISSION": "Włącz powiadomienia push w przeglądarce, aby móc je otrzymywać",
        "ALLOW_NOTIFICATION_DURING_CALL": "Zezwalaj na powiadomienia push podczas rozmowy",
        "TEST_PUSH": "Testuj",
        "TESTING": "Testowanie...",
        "TEST_PUSH_DESCRIPTION": "Wyślij testowe powiadomienia, aby zweryfikować konfigurację",
        "TEST_NOTIFICATION_ERROR": "Nie udało się wysłać powiadomienia testowego. Spróbuj ponownie.",
        "TEST_LOCAL_TITLE": "Powiadomienie testowe (lokalne)",
        "TEST_LOCAL_BODY": "To jest lokalne powiadomienie przeglądarki. Jeśli je widzisz, powiadomienia przeglądarki działają!"
      },
      "API": {
        "UPDATE_SUCCESS": "Twoje preferencje powiadomień zostały pomyślnie zaktualizowane",
        "UPDATE_ERROR": "Wystąpił błąd podczas aktualizacji preferencji, spróbuj ponownie"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Powiadomienia push",
        "NOTE": "Zaktualizuj tutaj swoje preferencje powiadomień push",
        "CONVERSATION_ASSIGNMENT": "Wysyłaj powiadomienia push, gdy rozmowa zostanie przypisana do mnie",
        "CONVERSATION_CREATION": "Wysyłaj powiadomienia push, gdy zostanie utworzona nowa rozmowa",
        "CONVERSATION_MENTION": "Wysyłaj powiadomienia push, gdy zostaniesz wspomniany w rozmowie",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Wysyłaj powiadomienia push, gdy pojawi się nowa wiadomość w przypisanej rozmowie",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Wysyłaj powiadomienia push, gdy pojawi się nowa wiadomość w rozmowie, w której uczestniczysz",
        "HAS_ENABLED_PUSH": "Powiadomienia push są włączone w tej przeglądarce.",
        "REQUEST_PUSH": "Włącz powiadomienia push",
        "SLA_MISSED_FIRST_RESPONSE": "Wysyłaj powiadomienia push, gdy rozmowa nie spełni SLA pierwszej odpowiedzi",
        "SLA_MISSED_NEXT_RESPONSE": "Wysyłaj powiadomienia push, gdy rozmowa nie spełni SLA kolejnej odpowiedzi",
        "SLA_MISSED_RESOLUTION": "Wysyłaj powiadomienia push, gdy rozmowa nie spełni SLA rozwiązania"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Zdjęcie profilowe"
      },
      "NAME": {
        "LABEL": "Imię i nazwisko",
        "ERROR": "Wprowadź prawidłowe imię i nazwisko",
        "PLACEHOLDER": "Wprowadź imię i nazwisko"
      },
      "DISPLAY_NAME": {
        "LABEL": "Nazwa wyświetlana",
        "ERROR": "Wprowadź prawidłową nazwę wyświetlaną",
        "PLACEHOLDER": "Wprowadź nazwę wyświetlaną, będzie widoczna w rozmowach"
      },
      "POSITION": {
        "LABEL": "Stanowisko",
        "ERROR": "Wprowadź prawidłowe stanowisko",
        "PLACEHOLDER": "Wprowadź swoje stanowisko"
      },
      "CUSTOM_LINE": {
        "LABEL": "Linia niestandardowa",
        "ERROR": "Wprowadź prawidłową linię niestandardową",
        "PLACEHOLDER": "Wprowadź swoją linię niestandardową"
      },
      "AVAILABILITY": {
        "LABEL": "Dostępność",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Zajęty",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Dostępność została pomyślnie ustawiona",
        "SET_AVAILABILITY_ERROR": "Nie udało się ustawić dostępności, spróbuj ponownie"
      },
      "EMAIL": {
        "LABEL": "Twój adres e-mail",
        "ERROR": "Wprowadź prawidłowy adres e-mail",
        "PLACEHOLDER": "Wprowadź swój adres e-mail, będzie widoczny w rozmowach"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Obecne hasło",
        "ERROR": "Wprowadź obecne hasło",
        "PLACEHOLDER": "Wprowadź obecne hasło"
      },
      "PASSWORD": {
        "LABEL": "Nowe hasło",
        "ERROR": "Wprowadź hasło o długości co najmniej 6 znaków",
        "PLACEHOLDER": "Wprowadź nowe hasło"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Potwierdź nowe hasło",
        "ERROR": "Potwierdzenie hasła musi być zgodne z hasłem",
        "PLACEHOLDER": "Wprowadź ponownie nowe hasło"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Zmień",
    "CHANGE_ACCOUNTS": "Zmień konto",
    "SWITCH_ACCOUNT": "Przełącz konto",
    "CONTACT_SUPPORT": "Skontaktuj się z pomocą techniczną",
    "REPORT_BUG": "Zgłoś błąd",
    "SELECTOR_SUBTITLE": "Wybierz konto z poniższej listy",
    "PROFILE_SETTINGS": "Ustawienia profilu",
    "KEYBOARD_SHORTCUTS": "Skróty klawiszowe",
    "APPEARANCE": "Zmień wygląd",
    "SUPER_ADMIN_CONSOLE": "Konsola SuperAdmin",
    "DOCS": "Czytaj dokumentację",
    "LOGOUT": "Wyloguj się"
  },
  "BUG_REPORT": {
    "TITLE": "Zgłoś błąd",
    "DESCRIPTION_LABEL": "Opis problemu",
    "DESCRIPTION_PLACEHOLDER": "Opisz napotkany problem...",
    "SUBMIT": "Wyślij zgłoszenie",
    "SUBMITTING": "Wysyłanie...",
    "CANCEL": "Anuluj",
    "SUCCESS": "Zgłoszenie zostało wysłane. Dziękujemy!",
    "ERROR": "Nie udało się wysłać zgłoszenia. Spróbuj ponownie.",
    "VALIDATION_ERROR": "Opisz problem przed wysłaniem"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dni okresu próbnego pozostało.",
    "TRAIL_BUTTON": "Kup teraz",
    "DELETED_USER": "Usunięty użytkownik",
    "EMAIL_VERIFICATION_PENDING": "Wygląda na to, że nie zweryfikowałeś jeszcze swojego adresu e-mail. Sprawdź skrzynkę odbiorczą.",
    "RESEND_VERIFICATION_MAIL": "Wyślij ponownie e-mail weryfikacyjny",
    "EMAIL_VERIFICATION_SENT": "E-mail weryfikacyjny został wysłany. Sprawdź swoją skrzynkę odbiorczą.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Konto zawieszone",
      "MESSAGE": "Twoje konto zostało zawieszone. Skontaktuj się z zespołem wsparcia, aby uzyskać więcej informacji."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiuj",
      "CODEPEN": "Otwórz w CodePen",
      "COPY_SUCCESSFUL": "Skopiowano do schowka"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Pokaż więcej",
      "SHOW_LESS": "Pokaż mniej"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Pobierz",
      "UPLOADING": "Przesyłanie...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ta relacja nie jest już dostępna.",
      "RECORDING_UNAVAILABLE": "To nagranie nie jest już dostępne.",
      "DELETE_RECORDING": {
        "BUTTON": "Usuń nagranie rozmowy",
        "TITLE": "Usunąć nagranie rozmowy?",
        "DESCRIPTION": "Wszystkie nagrania tej rozmowy zostaną trwale usunięte z centrali telefonicznej i nie będzie można ich przywrócić. Transkrypcja i podsumowanie rozmowy pozostaną.",
        "CONFIRM": "Usuń",
        "SUCCESS": "Nagranie rozmowy zostało usunięte",
        "ERROR": "Nie udało się usunąć nagrania rozmowy. Spróbuj ponownie."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Zobacz na mapie"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Wyślij"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Ten obraz nie jest już dostępny.",
      "LOADING_FAILED": "Ładowanie nie powiodło się"
    }
  },
  "CONFIRM_EMAIL": "Weryfikowanie...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Dodaj skrzynkę"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Brak elementów",
    "CURRENTLY_VIEWING_ACCOUNT": "Aktualnie przeglądasz:",
    "SWITCH": "Przełącz",
    "INBOX_VIEW": "Widok skrzynki",
    "CONVERSATIONS": "Rozmowy",
    "INBOX": "Moja skrzynka",
    "ALL_CONVERSATIONS": "Wszystkie rozmowy",
    "MENTIONED_CONVERSATIONS": "Wzmianki",
    "PARTICIPATING_CONVERSATIONS": "Uczestniczące",
    "UNATTENDED_CONVERSATIONS": "Nieobsłużone",
    "REPORTS": "Raporty",
    "SETTINGS": "Ustawienia",
    "CONTACTS": "Kontakty",
    "DATA_ASSISTANT": "Asystent danych",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Asystenci",
    "CAPTAIN_DOCUMENTS": "Dokumenty",
    "CAPTAIN_RESPONSES": "FAQ",
    "HOME": "Strona główna",
    "AGENTS": "Agenci",
    "AGENT_BOTS": "Boty",
    "AUDIT_LOGS": "Dzienniki audytu",
    "WHATSAPP_TEMPLATES": "Szablony WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Skrzynki",
    "NOTIFICATIONS": "Powiadomienia",
    "CANNED_RESPONSES": "Gotowe odpowiedzi",
    "INTEGRATIONS": "Integracje",
    "PROFILE_SETTINGS": "Ustawienia profilu",
    "ACCOUNT_SETTINGS": "Ustawienia konta",
    "APPLICATIONS": "Aplikacje",
    "LABELS": "Etykiety",
    "CUSTOM_ATTRIBUTES": "Atrybuty niestandardowe",
    "AUTOMATION": "Automatyzacja",
    "MACROS": "Makra",
    "TEAMS": "Zespoły",
    "BILLING": "Rozliczenia",
    "CUSTOM_VIEWS_FOLDER": "Foldery",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenty",
    "ALL_CONTACTS": "Wszystkie kontakty",
    "TAGGED_WITH": "Oznaczone jako",
    "NEW_LABEL": "Nowa etykieta",
    "NEW_TEAM": "Nowy zespół",
    "NEW_INBOX": "Nowa skrzynka",
    "REPORTS_CONVERSATION": "Rozmowy",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Czat na żywo",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampanie",
    "ONGOING": "Trwające",
    "ONE_OFF": "Jednorazowe",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenci",
    "REPORTS_LABEL": "Etykiety",
    "REPORTS_INBOX": "Skrzynka",
    "REPORTS_TEAM": "Zespół",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Przegląd",
    "WALLBOARD_QUEUES": "Kolejki",
    "WALLBOARD_AGENTS": "Przegląd agentów",
    "DATA_ASSISTANT_CHAT": "Czat",
    "DATA_ASSISTANT_REPORTS": "Raporty",
    "NO_WAITING_CALLERS": "brak oczekujących dzwoniących",
    "WAITING_CALLERS": "{count} oczekujących dzwoniących",
    "SET_AVAILABILITY_TITLE": "Ustaw siebie jako",
    "SET_YOUR_AVAILABILITY": "Ustaw swoją dostępność",
    "AVAILABILITY_IMPERSONATING": "Zablokowane podczas logowania jako ten użytkownik",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Role niestandardowe",
    "NEW_CONVERSATION": "Nowa rozmowa",
    "DRAFT": "Szkic",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Przegląd",
    "REAUTHORIZE": "Połączenie Twojej skrzynki wygasło, połącz ponownie,\n aby kontynuować odbieranie i wysyłanie wiadomości",
    "HELP_CENTER": {
      "TITLE": "Centrum pomocy",
      "ARTICLES": "Artykuły",
      "CATEGORIES": "Kategorie",
      "LOCALES": "Języki",
      "SETTINGS": "Ustawienia",
      "DICTIONARY": "Słownik"
    },
    "CHANNELS": "Kanały",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Automatycznie oznacz jako offline",
      "INFO_TEXT": "Pozwól systemowi automatycznie oznaczać Cię jako offline, gdy nie korzystasz z aplikacji ani panelu.",
      "INFO_SHORT": "Automatycznie ustawiaj status offline, gdy nie korzystasz z aplikacji."
    },
    "DOCS": "Czytaj dokumentację"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Zablokowane domeny i kontakty",
    "DESCRIPTION": "Lista zablokowanych domen e-mail dla tego konta.",
    "NO_BLOCKED_DOMAINS": "Nie znaleziono zablokowanych domen.",
    "BLOCKED_CONTACTS_BTN": "Zablokowane kontakty"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Rozliczenia",
    "DESCRIPTION": "Zarządzaj subskrypcją, ulepsz plan i uzyskaj więcej dla swojego zespołu.",
    "CURRENT_PLAN": {
      "TITLE": "Bieżący plan",
      "PLAN_NOTE": "Obecnie subskrybujesz plan **{plan}** z **{quantity}** licencjami",
      "SEAT_COUNT": "Liczba miejsc",
      "RENEWS_ON": "Odnawia się"
    },
    "VIEW_PRICING": "Zobacz ceny",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Zarządzaj subskrypcją",
      "DESCRIPTION": "Wyświetlaj poprzednie faktury, edytuj dane rozliczeniowe lub anuluj subskrypcję.",
      "BUTTON_TXT": "Przejdź do portalu rozliczeń"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Zarządzaj użyciem i kredytami Captain AI.",
      "BUTTON_TXT": "Kup więcej kredytów",
      "DOCUMENTS": "Dokumenty",
      "RESPONSES": "Odpowiedzi",
      "UPGRADE": "Captain nie jest dostępny w planie darmowym. Przejdź na wyższy plan, aby uzyskać dostęp do asystentów, copilot i innych funkcji."
    },
    "CHAT_WITH_US": {
      "TITLE": "Potrzebujesz pomocy?",
      "DESCRIPTION": "Masz problemy z rozliczeniami? Jesteśmy tu, aby pomóc.",
      "BUTTON_TXT": "Porozmawiaj z nami"
    },
    "NO_BILLING_USER": "Twoje konto rozliczeniowe jest konfigurowane. Odśwież stronę i spróbuj ponownie."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ups! Nie znaleźliśmy żadnych kont. Utwórz nowe konto, aby kontynuować.",
    "NEW_ACCOUNT": "Nowe konto",
    "SELECTOR_SUBTITLE": "Utwórz nowe konto",
    "API": {
      "SUCCESS_MESSAGE": "Konto zostało utworzone pomyślnie",
      "EXIST_MESSAGE": "Konto już istnieje",
      "ERROR_MESSAGE": "Nie udało się połączyć z serwerem czatu, spróbuj ponownie później"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nazwa firmy",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Zapisz",
      "CANCEL": "Anuluj"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Pokaż wszystkie skróty",
    "TITLE": {
      "OPEN_CONVERSATION": "Otwórz rozmowę",
      "RESOLVE_AND_NEXT": "Rozwiąż i przejdź do następnej",
      "NAVIGATE_DROPDOWN": "Nawigacja po elementach listy rozwijanej",
      "RESOLVE_CONVERSATION": "Rozwiąż rozmowę",
      "GO_TO_CONVERSATION_DASHBOARD": "Przejdź do panelu rozmów",
      "ADD_ATTACHMENT": "Dodaj załącznik",
      "GO_TO_CONTACTS_DASHBOARD": "Przejdź do panelu kontaktów",
      "TOGGLE_SIDEBAR": "Przełącz panel boczny",
      "GO_TO_REPORTS_SIDEBAR": "Przejdź do panelu raportów",
      "MOVE_TO_NEXT_TAB": "Przejdź do następnej karty na liście rozmów",
      "GO_TO_SETTINGS": "Przejdź do ustawień",
      "SWITCH_TO_PRIVATE_NOTE": "Przełącz na notatkę prywatną",
      "SWITCH_TO_REPLY": "Przełącz na odpowiedź",
      "TOGGLE_SNOOZE_DROPDOWN": "Przełącz listę odkładania",
      "AI_ASSIST_MENU": "Asystent AI",
      "AI_ASSIST_GRAMMAR": "Popraw gramatykę",
      "AI_ASSIST_UNIFY_LANG": "Ujednolić język wiadomości"
    }
  }
}
